module.exports = __webpack_public_path__ + "static/media/luke.595ac9e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/luke.jpg
// module id = 32
// module chunks = 0